import type {VideoItemObject} from '@PosterWhiteboard/items/video-item/video-item.class';
import {VideoItem} from '@PosterWhiteboard/items/video-item/video-item.class';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {Page} from '@PosterWhiteboard/page/page.class';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';
import type {BaseBackgroundObject} from '@PosterWhiteboard/page/background/background.types';

export interface VideoBackgroundObject extends BaseBackgroundObject, VideoItemObject {
  type: BackgroundTypeName.VIDEO;
}

export class VideoBackground extends VideoItem {
  public override gitype = ITEM_TYPE.VIDEOBACKGROUND;
  public type: BackgroundTypeName.VIDEO = BackgroundTypeName.VIDEO;

  public constructor(page: Page) {
    super(page);
  }

  public override toObject(): VideoBackgroundObject {
    return {
      ...super.toObject(),
      type: this.type,
    };
  }

  public override async updateFabricObject(): Promise<void> {
    await super.updateFabricObject();
    this.fabricObject.set({
      scaleX: (this.page.poster.width + 1) / this.fabricObject.width,
      scaleY: (this.page.poster.height + 1) / this.fabricObject.height,
      x: -1,
      y: -1,
    });
  }

  public async onBackgroundCreated(): Promise<void> {
    this.page.setBackgroundImage(this.fabricObject);
    await this.onItemAddedToPage();
    this.page.calculateAndUpdatePageDuration();
  }

  protected isCurrentItemPageBackground(): boolean {
    return this.page.fabricCanvas.backgroundImage === this.fabricObject;
  }

  protected override async reInitFabricObject(): Promise<void> {
    await this.beforeInitFabricObject();
    const isCurrentItemPageBackground = this.isCurrentItemPageBackground();
    await this.initFabricObject();
    if (isCurrentItemPageBackground) {
      this.page.setBackgroundImage(this.fabricObject);
    }
  }
}

export const createVideoBackgroundFromObject = async (page: Page, opts: Partial<VideoBackgroundObject>): Promise<VideoBackground> => {
  const background = new VideoBackground(page);
  await background.init(opts);
  return background;
};
